import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export function ErrorState({
  status = 'error',
  title = 'Đã có lỗi xảy ra',
  subTitle = 'Không thể tải được dữ liệu yêu cầu. Vui lòng thử lại sau.',
  onRetry,
}) {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '40px 16px', background: '#fff', borderRadius: 8, margin: '24px auto', maxWidth: 600 }}>
      <Result
        status={status}
        title={title}
        subTitle={subTitle}
        extra={[
          onRetry && (
            <Button type="primary" key="retry" onClick={onRetry}>
              Thử lại
            </Button>
          ),
          <Button key="home" onClick={() => navigate('/courses')}>
            Về danh sách khóa học
          </Button>,
        ]}
      />
    </div>
  );
}
